import { useState } from "react";
import "./challenge-theme-question-item.css";
//
import { IoIosArrowUp, IoIosArrowDown } from "react-icons/io";
import { BsCheck2Circle } from "react-icons/bs";
import { SlClose } from "react-icons/sl";
import StatusComponent from "../../../../ui/atoms/status/StatusComponent";
import Button from "../../../../ui/atoms/buttons/Button";
import CheckBox from "../../../../ui/atoms/checkbox/CheckBox";
import {
  capitalize,
  capitalizeAll,
  convertDuration,
  unSlugify,
} from "../../../../core/utils/helpers";
import moment from "moment";
import { challengeSlice } from "../../../../app/store/slices/challengeSlice";
import { useDispatch } from "react-redux";

const ChallengeThemeQuestionItem = ({
  index,
  mode,
  question_data,
  isCheckBox,
  isActionsButton = true,
  isDisplayLanguage = true,
  isRemoveButton = false,
  removeFunction,
  onRelease,
  onArchive,
  onUpdate,
}) => {
  const dispatch = useDispatch();
  const [isDrawer, setIsDrawer] = useState(false);
  const [selectedChallengeQuestionsIds, setSelectedChallengeQuestionsIds] =
    useState([]);
  const [selectedChallengeQuestions, setSelectedChallengeQuestions] = useState(
    [],
  );

  const question_id = question_data?.question_id;
  const language = question_data?.qv_language;
  const released_status = question_data?.is_activated;
  const archived_status = question_data?.is_deleted;
  const created_at = question_data?.created_at;
  const type = question_data?.type;
  const difficulty = question_data?.difficulty;
  const measure_indicator = question_data?.measure_indicator;
  const points = question_data?.points;
  const timing = question_data?.timing;
  const random_answer_order = question_data?.random_answer_order;
  const qv_cover_audio = question_data?.qv_cover_audio;
  const qv_cover_image = question_data?.qv_cover_image;
  const qv_description = question_data?.qv_description;
  const qv_explanations = question_data?.qv_explanations;
  const qv_answers = question_data?.qv_answers;

  const onSelectedQuestion = (idx, question_id) => {
    setSelectedChallengeQuestionsIds((prevSelected) =>
      prevSelected.includes(idx)
        ? prevSelected.filter((item) => item !== idx)
        : [...prevSelected, idx],
    );
    // Set Local State
    setSelectedChallengeQuestions((prev) => {
      const exists = prev.some((q) => q.question_id === question_id);

      const updated = exists
        ? prev.filter((q) => q.question_id !== question_id)
        : [...prev, question_data];

      // Dispatch avec la valeur à jour
      dispatch(challengeSlice.actions.setSelectedQuestions(updated));

      return updated;
    });
  };

  return (
    <div
      className={isDrawer ? "c-t-question-item h-auto" : "c-t-question-item"}
    >
      <div className="c-t-question-item-head">
        <div className="w-fit-content d-flex align-center gap-xs">
          {isCheckBox && (
            <CheckBox
              id={index}
              checked={selectedChallengeQuestionsIds.includes(index)}
              onChange={() => onSelectedQuestion(index, question_id)}
            />
          )}
          <span
            className={
              language === "en" ? "question-tick en" : "question-tick fr"
            }
          >
            Question {index}.{" "}
            {isDisplayLanguage && (language === "en" ? "English" : "French")}
          </span>
        </div>
        <div className="w-fit-content d-flex align-center">
          {isRemoveButton && (
            <span className="action-tick" onClick={() => removeFunction()}>
              <SlClose className="icon" />
            </span>
          )}
          <span className="action-tick" onClick={() => setIsDrawer(!isDrawer)}>
            {isDrawer ? (
              <IoIosArrowUp className="icon" />
            ) : (
              <IoIosArrowDown className="icon" />
            )}
          </span>
        </div>
      </div>
      <div className="c-t-question-item-wrapper">
        {isDisplayLanguage && (
          <div className="row gap-xs mb-xs">
            <StatusComponent
              type={released_status ? "success" : "error"}
              title={`Question ${
                released_status ? "Released" : "Not Released"
              }`}
            />
            <StatusComponent
              type={archived_status ? "error" : "success"}
              title={`Question ${
                archived_status ? "Archived" : "Not Archived"
              }`}
            />
          </div>
        )}
        <div className="row">
          <span className="span-label">Question created </span>
          <span className="span-mark">
            {moment(created_at).fromNow(false)} (
            {moment(created_at).format("LLLL")})
          </span>
        </div>
        <div className="row">
          <span className="span-label">Type :</span>
          <span className="span-mark">
            {type === "OCA" && "Once Choice Answer"}
            {type === "MCA" && "Multiple Choice Answers"}
            {type === "FIB" && "Fill in the Blanks"}
          </span>
        </div>
        {difficulty && (
          <div className="row">
            <span className="span-label">Difficulty :</span>
            <span className="span-mark">{capitalize(difficulty)}</span>
          </div>
        )}
        {measure_indicator && (
          <div className="row">
            <span className="span-label">Measure Indicator :</span>
            <span className="span-mark">
              {capitalizeAll(unSlugify(measure_indicator))}
            </span>
          </div>
        )}
        <div className="row">
          <span className="span-label">Points :</span>
          <span className="span-mark">{points} Points</span>
        </div>
        <div className="row">
          <span className="span-label">Duration :</span>
          <span className="span-mark">{convertDuration(timing)}</span>
        </div>
        <div className="row">
          <span className="span-label">Random Order of Answers :</span>
          <span className="span-mark">
            {random_answer_order ? "Yes" : "No"}
          </span>
        </div>
        {isActionsButton && (
          <div className="row gap-xs mt-xs mb-md">
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={`${
                released_status
                  ? "Click to UnRelease Question"
                  : "Click to Release Question"
              }`}
              action={() => onRelease()}
            />
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={`${
                archived_status
                  ? "Click to UnArchive Question"
                  : "Click to Archive Question"
              }`}
              action={() => onArchive()}
            />
            <Button
              type={"button"}
              preferedStyle={"default"}
              title={"Click to Update Question"}
              action={() => onUpdate()}
            />
          </div>
        )}
        {qv_cover_audio && (
          <div className="w-full mb-md mt-md">
            <audio
              className="w-full"
              controls
              controlsList="nodownload"
              onContextMenu={(e) => e.preventDefault()}
            >
              <source
                src={
                  !isDisplayLanguage
                    ? URL.createObjectURL(qv_cover_audio)
                    : `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/audios/${mode}/${qv_cover_audio}`
                }
                type={qv_cover_audio?.type}
              />
            </audio>
          </div>
        )}
        {qv_cover_image && (
          <div className="w-full mt-xs mb-xs" style={{ textAlign: "center" }}>
            <img
              src={
                !isDisplayLanguage
                  ? URL.createObjectURL(qv_cover_image)
                  : `${process.env.REACT_APP_API_SERVER_URL}:${process.env.REACT_APP_API_SERVER_PORT}/storage/images/${mode}/${qv_cover_image}`
              }
              alt="cover question illustration"
              style={{ maxWidth: "100%" }}
              onContextMenu={(e) => e.preventDefault()}
            />
          </div>
        )}
        <div className="col mb-lg">
          <span>Question text</span>
          <hr />
          <p
            dangerouslySetInnerHTML={{
              __html: qv_description,
            }}
          />
        </div>
        <div className="col mb-lg">
          <span>Question Explanations</span>
          <hr />
          <p
            dangerouslySetInnerHTML={{
              __html: qv_explanations,
            }}
          />
        </div>
        <div className="answers-wrapper">
          {qv_answers?.map((answer, idx) => {
            return (
              <div
                className={
                  answer?.is_correct
                    ? "answer-item is-good"
                    : "answer-item is-wrong"
                }
                key={idx}
              >
                {answer?.is_correct ? (
                  <span>
                    <BsCheck2Circle className="icon" />
                  </span>
                ) : (
                  <span>
                    <SlClose className="icon" />
                  </span>
                )}
                <p
                  dangerouslySetInnerHTML={{
                    __html: answer?.answer,
                  }}
                />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ChallengeThemeQuestionItem;
